import type { Location } from '@backoffice-frontend/graphql'
import { useTheme } from '@backoffice-frontend/patterns'
import { useContext } from 'react'
import { useHereLocation, useLine } from '../hooks'
import { HereMapContext } from './HereMap'

type MapLineProps = {
  from: Location
  to: Location
}

/**
 * MapLine shows a line between two points on the map.
 * It should be used as a direct child of the `HereMap` component.
 * @param from The start point of the line.
 * @param to The end point of the line.
 */
export const MapLine = (props: MapLineProps) => {
  const theme = useTheme()
  const { map } = useContext(HereMapContext)

  const from = useHereLocation(props.from)
  const to = useHereLocation(props.to)

  useLine({
    map,
    from,
    to,
    color: theme.semantic.ColorContentReduced,
  })

  return null
}
